import { render } from "./VoiceAssistant.vue?vue&type=template&id=665e6b9e&scoped=true"
import script from "./VoiceAssistant.vue?vue&type=script&lang=js"
export * from "./VoiceAssistant.vue?vue&type=script&lang=js"

import "./VoiceAssistant.vue?vue&type=style&index=0&id=665e6b9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665e6b9e"]])

export default __exports__